<script lang="ts">
  import { getStr } from '../../../../../common/util';
  export let data;
</script>

<div class="tile-offer-container">
  <div class="content">
    {#if data?.offersLabel}
      <span class="offers"
        >{@html data?.offersLabel}
        {#if data?.freeGiftCount}
          <span class="dot d-inline-flex align-middle"> </span>
        {/if}
      </span>
    {/if}
    {#if data?.freeGiftCount}
      <span class="free-gift">
        {getStr('extra.homepage.deals.giftCount', [data?.freeGiftCount])}
      </span>
    {/if}
  </div>
</div>

<style lang="scss">
  @import '../../../styles/colors.new.scss';
  .tile-offer-container {
    font-size: 12px;
    line-height: 14px;
    @include desktop-min-width {
      font-size: 14px;
      line-height: 16px;
    }
    .content {
      font-weight: 500;
      color: $functional-orange;
      .offers {
        .dot {
          width: 2px;
          height: 2px;
          background: $functional-orange;
          border-radius: 50%;
          margin: 0 2px;
        }
      }
    }
  }
</style>
